export default __webpack_public_path__ + "static/media/background-icon.ee2523fa.png";